<template>
  <div :class="type == undefined? 'household_frame':'household_frame_KNS'">
    <el-dialog
      title="請選擇住戶資訊(棟別、樓層、戶別)"
      :visible.sync="openSwitch"
      :close-on-click-modal="false"
      :show-close="isShowClose"
    >
      <span
        v-if="title != undefined"
        slot="title"
        class="dialog-title"
      >
        <div class="title-bar">
          <span class="title">
            {{ title.title }}
            <span
              v-if="title.introduction"
              class="introduction"
              @click="$toExternaLink(title.introduction)"
            >{{ $t("General.Instructions") }}</span>
          </span>
          <span class="subtitle">{{ title.SubTitle }}</span>
        </div>
        <div
          v-if="title.btn != undefined"
          class="advanced-cog"
          @click="title.btn.btnevent"
        >
          <i
            :class="title.btn.icon"
            aria-hidden="true"
          />
          {{ title.btn.text }}
        </div>
      </span>
      <div class="list_wrap">
        <template v-for="(lv,li) in houseList">
          <div
            :key="'block'+li"
            class="list_block"
          >
            <ol
              v-loading="loading[li]"
              style="height: 283px"
            >
              <p class="title">
                {{ lv.title }}
              </p>
              <li
                v-for="(iv, ii) in lv.listItems"
                :key="ii"
                :class="{'active':JSON.stringify(activeData[li])==JSON.stringify(iv)}"
                @click="selectItem(li,iv)"
              >
                <span v-if="lv.name=='Tags'">{{ iv.tag }}</span>
                <span v-if="lv.name=='Floors'">第{{ iv.floor }}樓</span>
                <span v-if="lv.name=='Notes'">{{ iv.tablet_note }}</span>
              </li>
            </ol>
          </div>
          <div
            v-if="li+1<houseList.length"
            :key="'arrow'+li"
            class="list_arrow"
          >
            <i
              class="el-icon-arrow-right"
              aria-hidden="true"
            />
          </div>
        </template>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    open: Boolean,
    type: '',
    title: Object,
    isShowClose: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showVirtual: true, // 是否顯示虛擬戶
      loading: [false, false, false],
      activeBlock: 0,
      activeData: [],
      houseList: [
        {
          title: '請選擇棟別',
          name: 'Tags',
          apiUrl: '/api/GetComTabletTag',
          listItems: []
        },
        {
          title: '請選擇樓層',
          name: 'Floors',
          apiUrl: '/api/GetComTabletFloor',
          postData: ['tag'],
          listItems: []
        },
        {
          title: '請選擇戶別',
          name: 'Notes',
          apiUrl: '/api/GetComTabletNote',
          postData: ['tag', 'floor'],
          listItems: []
        }
      ]
    }
  },
  computed: {
    openSwitch: {
      get: function () {
        return this.open
      },
      set: function (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
    activeBlock (index) {
      this.houseList.forEach((val, ind) => {
        if (ind > index + 1) {
          val.listItems.length = 0
        }
      })
      this.activeData.filter((val, ind) => {
        if (ind > index) {
          return val
        }
      })
    }
  },
  mounted () {
    this.initList()
  },
  methods: {
    initList () {
      this.getComTag()
      this.showVirtual = true
    },
    openNotShowVirtual () { // 開啟彈窗，並設定不顯示虛擬戶別
      console.log('開啟彈窗，並設定不顯示虛擬戶別')
      this.openSwitch = true
      this.showVirtual = false
    },
    selectItem (blockIndex, itemValue) { // 點選欄位項目
      this.activeBlock = blockIndex
      this.activeData = _cloneDeep(this.activeData.filter((val, ind) => { // 清除歷史點擊資料
        if (ind < blockIndex) {
          return val
        }
      }))
      this.activeData.push(itemValue) // 新增歷史點擊資料
      // eslint-disable-next-line eqeqeq
      if (blockIndex + 1 == this.houseList.length) { // 結束選擇
        this.finishSelected(itemValue)
      } else {
        this.getList(this.houseList[blockIndex + 1].name)
      }
    },
    finishSelected (note) { // 選擇結束
      this.$emit('select-household', note)
    },
    getList (listName) { // 取得項目列表
      switch (listName) {
      case 'Tags':
        break
      case 'Floors':
        this.getComFloor(this.activeData[0])
        break
      case 'Notes':
        this.getComNote(this.activeData[0], this.activeData[1])
        break
      default:
        this.getComTag()
        break
      }
    },
    getComTag () { // 取得棟別
      this.loading[0] = true
      const url = process.env.NODE_ENV === 'development' ? '/house/getComTabletTag' : `${process.env.VUE_APP_WS_URL}/getComTabletTag`
      axios(url, {
        method: 'POST'
      }).then((res) => {
        this.houseList[0].listItems = res.data
        this.loading[0] = false
      }).catch(err => {
        this.$message({
          message: '取得棟別失敗，請稍後再試',
          type: 'warning'
        })
        console.log(err.response)
      })
    },
    getComFloor (tag) { // 取得樓層
      this.loading[1] = true
      const postData = new FormData()
      postData.append('t', tag.tag)
      const url = process.env.NODE_ENV === 'development' ? '/house/getComTabletFloor' : `${process.env.VUE_APP_WS_URL}/getComTabletFloor`
      axios(url, {
        method: 'POST',
        data: postData
      }).then((res) => {
        this.houseList[1].listItems = res.data
        this.loading[1] = false
      }).catch(err => {
        this.$message({
          message: '取得樓層失敗，請稍後再試',
          type: 'warning'
        })
        console.log(err.response)
      })
    },
    getComNote (tag, floor) { // 取得戶別
      this.loading[2] = true
      const postData = new FormData()
      postData.append('t', tag.tag)
      postData.append('f', floor.floor)
      const url = process.env.NODE_ENV === 'development' ? '/house/getComTabletNote' : `${process.env.VUE_APP_WS_URL}/getComTabletNote`
      axios(url, {
        method: 'POST',
        data: postData
      }).then((res) => {
        if (this.showVirtual) { // 顯示虛擬戶
          this.houseList[2].listItems = res.data
        } else {
          this.houseList[2].listItems = []
          res.data.forEach(item => {
            // eslint-disable-next-line eqeqeq
            if (item.is_virtual == 0) { this.houseList[2].listItems.push(item) }
          })
        }
        this.loading[2] = false
      }).catch(err => {
        this.$message({
          message: '取得戶別失敗，請稍後再試',
          type: 'warning'
        })
        console.log(err.response)
      })
    },
    clearHousehold () { // 清除選擇的住戶
      this.loading = [false, false, false]
      this.activeBlock = 0
      this.activeData = []
      this.houseList = [
        {
          title: '請選擇棟別',
          name: 'Tags',
          apiUrl: '/api/GetComTabletTag',
          listItems: []
        },
        {
          title: '請選擇樓層',
          name: 'Floors',
          apiUrl: '/api/GetComTabletFloor',
          postData: ['tag'],
          listItems: []
        },
        {
          title: '請選擇戶別',
          name: 'Notes',
          apiUrl: '/api/GetComTabletNote',
          postData: ['tag', 'floor'],
          listItems: []
        }
      ]
      this.initList()
    }
  }
}
</script>
<style lang="sass" scoped>
.household_frame
  ::v-deep .el-dialog
    +basicDialog
  .list_wrap
    display: flex
    justify-content: space-between
    height: 290px
    font-size: map-get($fontSize,large)
    text-align: left
    .list_block
      width: 27.5%
      border: 1px solid $borderDark1
      padding: 5px
      padding-bottom: 0px
      overflow: auto
      .title
        color: $subFontColor
        padding: 4px 0
      li
        color: $mainFontColor
        padding: 4px 0
        &.active
          background-color: $defaultColorHover
    .list_arrow
      align-self: center
.household_frame_KNS
  ::v-deep .el-dialog
    +KNSDialog
  .list_wrap
    display: flex
    justify-content: space-between
    height: 290px
    font-size: map-get($fontSize,large)
    text-align: left
    .list_block
      width: 27.5%
      border: 1px solid $borderDark1
      padding: 5px
      padding-bottom: 0px
      overflow: auto
      .title
        color: $subFontColor
        padding: 4px 0
      li
        color: $mainFontColor
        padding: 4px 0
        &.active
          background-color: $defaultColorHover
    .list_arrow
      align-self: center
</style>
